import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Offer ingestion is now an internal-facing dashboard. Access is gated via the
// existing InsightsPortalOfferIngestionDashboard toggle, whose rollout is
// configured in Roulette to target internal accounts (e.g. @instacart.com).
export const insightsPortalOfferIngestionAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.Performance,
    featureToggles: [FeatureToggle.InsightsPortalOfferIngestionDashboard],
  },
]
